/* Imperial Candles homepage sections — carousel arrows + mobile progress bar */
if (!customElements.get('ich-slider')) {
  class IchSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ich-track');
      if (!this.track) return;
      this.prev = this.querySelector('[data-ich-prev]');
      this.next = this.querySelector('[data-ich-next]');
      this.fill = this.querySelector('.ich-progress__fill');
      this.onScroll = this.update.bind(this);
      this.prev && this.prev.addEventListener('click', () => this.go(-1));
      this.next && this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
    }
    step() {
      const item = this.track.children[0];
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / (item.offsetWidth + gap)));
      return perView * (item.offsetWidth + gap);
    }
    go(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      if (this.fill) {
        const ratio = t.scrollWidth ? t.clientWidth / t.scrollWidth : 1;
        this.fill.style.width = Math.min(100, ratio * 100) + '%';
        const progress = max > 0 ? t.scrollLeft / max : 0;
        this.fill.style.transform = 'translateX(' + progress * (1 / ratio - 1) * 100 + '%)';
      }
    }
  }
  customElements.define('ich-slider', IchSlider);
}
